export class EnumUtil {
    // tslint:disable-next-line:no-any
    static getEnumKeyByEnumValue = (myEnum: any, enumValue: any) => {
        // tslint:disable-next-line:triple-equals
        const keys = Object.keys(myEnum).filter((x) => myEnum[x] == enumValue)
        return keys.length > 0 ? keys[0] : null
    }
}